// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"skeleton_skeleton__VODJ7","shine":"skeleton_shine__WUQRR"};